'use strict';

const ChannelTabs = {
  init({ categoriesBaseUrl }, done) {
    const $primaryNav = document.querySelector('.primary-nav');

    if ($primaryNav) {
      const $activeLink = $primaryNav.querySelector(
        `a[href='${categoriesBaseUrl}']`
      );

      if ($activeLink) {
        $activeLink.parentNode.classList.add('active');
      }
    }

    return done();
  },
};

module.exports = ChannelTabs;
